//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EventsShorts from "@/components/objects/public/EventsShorts.vue";
import EventsDetail from "@/components/objects/public/EventsDetail.vue";

export default {
  name: "Default",
  components: {
    EventsDetail,
    EventsShorts,
  },
  props: {
    list: {
      type: Object,
      default: () => ({})
    },
    listInfo: {
      type: Object,
      default: () => ({})
    },
    prepopulatedItems: {
      type: Array,
      default: () => []
    },
    detail: {
      type: Boolean,
      default: false
    },
    templateValue: {
      type: Object,
      default: () => null
    },
    design: {
      type: String,
      default: () => 'default'
    },
    theme: {
      type: String,
      default: () => 'default'
    },
    design_extra: {
      type: Object,
      default: () => ({})
    },
    user: {
      type: Object,
      default: () => ({})
    },
    useStorage: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    localDetail: {
      get() {
        return this.detail
      },
      set(val) {
        this.$emit('detail', val)
      }
    }
  },
  methods: {
    onTemplateChange(evt) {
      this.$emit('template-change', evt)
      this.$nextTick(() => {
        if (this.$refs['events-shorts']) {
          this.$refs['events-shorts'].computeRowSize();
        }
      })
    }
  }
}
